export default function FormMeldung({ hinweis }) {
  if (!hinweis?.text) return null;
  const art = hinweis.typ === "ok" ? "ok" : "fehler";
  return (
    <p className={`form-meldung form-meldung-${art}`} role={art === "fehler" ? "alert" : "status"}>
      {hinweis.text}
    </p>
  );
}
